import React from 'react';
import Typography from '@mui/material/Typography';

interface IRowProps {
  hit: any;
}

const WatchlistData: React.FC<IRowProps> = ({ hit }) => {
  return (
    <>
      <div className='hb-primary-col'>
        <Typography className='hb-primary-col-typo'>
          {hit._source['Name of Entity']}
        </Typography>
      </div>
      <div className='hb-primary-col'>
        <Typography className='hb-primary-col-typo'>
          {hit._source.Program}
        </Typography>
      </div>
      <div className='hb-primary-col'>
        <Typography className='hb-primary-col-typo'>
          {hit._source['Source Country']}
        </Typography>
      </div>
      <div className='hb-primary-col'>
        <Typography className='hb-primary-col-typo'>
          {hit._source['List Name']}
        </Typography>
      </div>
    </>
  );
};

export default WatchlistData;
